import { CompetitionFilterPage } from './../competition-filter/competition-filter.page';
import { PlayerService } from './../../../../providers/player-service/player-service';
import {
  LoadingController,
  NavParams,
  NavController,
  ModalController,
  Platform,
  ViewDidEnter,
} from '@ionic/angular';
import {
  CompetitionList,
  CompetitionInfo,
  CompetitionDataPage,
  emptyCompetitionDataPage,
  CompetitionData,
  MergedCompetitionDetails,
  CompetitionDataLitePage,
  emptyCompetitionDataLitePage,
  CompetitionDataLite,
} from './../../../../data/mygolf.data';
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { CompetitionService } from '../../../../providers/competition-service/competition-service';
import { SearchCriteria } from '../../../../data/search-criteria';
import { Country } from '../../../../data/country-location';
import { emptyCompetitionList } from 'src/data/competition-data';
import { AuthenticationService } from 'src/authentication-service';
import { adjustViewZIndex, appType, clubId } from 'src/globals';
import * as moment from 'moment';
import { TranslationService } from 'src/i18n/translation-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Subscription } from 'rxjs';
import { CountryListPage } from '../../modal-screens/country-list/country-list.page';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';

@Component({
  selector: 'app-competition-list',
  templateUrl: './competition-list.page.html',
  styleUrls: ['./competition-list.page.scss'],
})
export class CompetitionListPage implements OnInit, ViewDidEnter {
  public searchQuery: string = '';
  public statistics: string = '';
  public refreshAttempted: boolean = false;
  public compList: CompetitionList;
  public competition: CompetitionDataLite;
  public selectedItem: NavParams;
  public tabs: string = 'all';
  public isAndroid: boolean = false;
  public countDays: number;
  public countDaysText: string;
  public countDaysRound: number;
  public searchCriteria: SearchCriteria;
  public needsRefresh: boolean = true;
  public selectedCountry: Country;

  public startDate: string;
  public viewMode: string = 'compact'; //classic | new
  initPage: boolean = true;
  constructor(
    private nav: NavController,
    private keyboard: Keyboard,
    private router: Router,
    private loading: LoadingController,
    private modal: ModalController,
    private renderer: Renderer2,
    private auth: AuthenticationService,
    private competitionService: CompetitionService,
    private playerService: PlayerService,
    private platform: Platform,
    private translateService: TranslationService,
    private mg2uUtil: mygolfUtils,
    private modalCtrl: ModalController,
    private changeDetectorRef: ChangeDetectorRef,
    private flightService: ClubFlightService,
  ) {
    this.searchQuery = '';
    this.compList = emptyCompetitionList();
    this.tabs = 'all';
    this.searchCriteria = this.competitionService.getSearch();
    if(!this.searchCriteria.viewMode || this.searchCriteria.viewMode === undefined) {
      this.searchCriteria.viewMode = this.viewMode;
    }

    if(this.searchCriteria?.searchQuery) this.searchQuery = this.searchCriteria.searchQuery;

    this.searchCriteria.searchType = this.tabs;
    // this.startDate = moment().startOf('month').subtract(1,'years').format('YYYY-MM-DD')
    // this.searchCriteria.searchDateFrom = moment().startOf('month').subtract(1,'years').toDate();
    if(this.searchCriteria?.searchDateFrom) {
        this.startDate = moment(this.searchCriteria.searchDateFrom).format('YYYY-MM-DD');
    } else {
      this.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.searchCriteria.searchDateFrom = moment().startOf('month').toDate();
    }

    //  = {
    //     searchType: this.tabs
    // };
    this.competitionService.setSearch(this.searchCriteria);
  }

  ngOnInit() {
    // this.doRefresh(null);

    this.getAppAttribute();
    this.initPage = true;
    console.debug("do on init")
    this._clearAndRefresh(null, null);
  }

  pageSize: number = 10;
  getAppAttribute() {
    this.pageSize = this.mg2uUtil.getSpecificAppAttributePage('competition')?.competitionList?.pageSize || 10;
  }
  async ionViewDidEnter() {

    console.debug("search query [did enter]: ", this.needsRefresh, this.mg2uUtil.getSearchPref('comp.list'))
    // if(this.mg2uUtil.getSearchPref('comp.list')) {
    //   (await this.mg2uUtil.getSearchPref('comp.list'))
    //   .subscribe((value)=>{
    //     this.searchCriteria.searchQuery = value
    //     this.competitionService.setSearch(this.searchCriteria);
    //     // this.searchQuery = value
    //   });

    // }
    // if(this.mg2uUtil.getSearchPref('comp.countryId')) {
    //   (await this.mg2uUtil.getSearchPref('comp.countryId'))
    //   .subscribe((value)=>{
    //     if(value) {
    //       this.searchCriteria.countryId = value;
    //       this.competitionService.setSearch(this.searchCriteria);
    //     }

    //   })
    // }
    // if (this.needsRefresh) {
    //   this.needsRefresh = false;
    //   this._clearAndRefresh(null, null);
    // }
    adjustViewZIndex(this.nav, this.renderer);
    this.initPage = false;
  }

  ionViewWillLeave() {
    if (this.platform.is('ios') && this.platform.is('capacitor'))
      this.keyboard.hide();
  }

  public startDaysText(competition) {
    let b = moment();
    let a = moment();
    this.countDaysText = '';
    let dateNow = moment();
    a = moment(competition.startDate);

    this.countDays = a.diff(b, 'days', true) + 1;
    this.countDays = Math.round(this.countDays * 100) / 100;
    this.countDaysRound = a.diff(b, 'days') + 1; // =1

    if (this.countDays >= 0.0 && this.countDays <= 0.99) {
      this.countDaysText = 'Today';
    }
    if (this.countDays < 0) {
      this.countDaysText = 'Not started yet';
    }
    if (this.countDays >= 1.0 && this.countDays <= 1.99) {
      this.countDaysText = 'Tomorrow ';
    }
    if (this.countDays >= 2) {
      this.countDaysText = 'In ' + this.countDaysRound + ' days';
    }
    let startDate = moment(competition.startDate);
    let endDate = moment(competition.endDate);
    if (moment(dateNow).isBetween(startDate, endDate)) {
      this.countDaysText = '';
    }

    return this.countDaysText;
  }

  public setSearchType(searchType: string) {

    this.searchCriteria = this.competitionService.getSearch();


    // this.searchCriteria = {
    //     searchType: searchType
    // };

    this.searchCriteria.searchType = searchType;

    if (searchType == 'private') this.competitionService.setPrivate(true);
    else this.competitionService.setPrivate(false);

    this.competitionService.setSearch(this.searchCriteria);
    // if its private, we need to pass different parameter to options, so it will ignore/hide upcoming/all radio filters

    this.onRefreshClick();
  }

  public regDaysText(competition) {
    let b = moment();
    let a = moment();
    this.countDaysText = '';
    let dateNow = moment();

    if (
      competition.status == 'Upcoming' &&
      !this.isClosedForRegistration(competition)
    ) {

      // !competition.closedForRegistration
      a = moment(competition.openDate);
    } else {
      a = moment(competition.startDate);
    }


    this.countDays = a.diff(b, 'days', true) + 1;
    this.countDays = Math.round(this.countDays * 100) / 100;
    this.countDaysRound = a.diff(b, 'days') + 1; // =1

    // console.debug("count days [0]", this.countDays, a.diff(b, 'days', true))
    // console.debug("count days [1]", Math.round(this.countDays * 100) / 100)
    // console.debug("count days [2]", this.countDaysRound)

    if (
      competition.status == 'Upcoming' &&
      !this.isClosedForRegistration(competition)
    ) {
      // !competition.closedForRegistration
      if (this.countDays >= 0.0 && this.countDays <= 0.99) {
        this.countDaysText = 'Opens today';
      }
      if (this.countDays < 0) {
        this.countDaysText = 'Opens today'; //Not opened yet
      }
      if (this.countDays >= 1.0 && this.countDays <= 1.99) {
        this.countDaysText = 'Opens tomorrow ';
      }
      if (this.countDays >= 2) {
        this.countDaysText = 'Opens in ' + this.countDaysRound + ' days';
      }
      let openDate = moment(competition.openDate);
      let closeDate = moment(competition.closeDate);
      if (moment(dateNow).isBetween(openDate, closeDate)) {
        this.countDaysText = 'Register now';
      }
    } else {
      this.countDaysText = 'Closed';
    }
    // this.countDaysText = moment(a).fromNow();


    return this.countDaysText;
  }

  getStatusIcon(competition: CompetitionDataLite) {
    let result = "";
    if (competition.status)
      switch (competition.status.toLowerCase()) {
        case "upcoming":
          result = "mdi mdi-calendar-clock";
          break;
        case "in progress":
          result = "mdi mdi-calendar-today";
          break;
        case "cancelled":
          result = "mdi mdi-calendar-remove";
          break;
        case "completed":
          result = "mdi mdi-calendar-check";
          break;
        case "not started":
          result = "mdi mdi-calendar-clock";
          break;
      }
    return result;
  }

  getStatusClass(competition: CompetitionDataLite) {
    let result = '';
    if (competition.status)
      switch (competition.status.toLowerCase()) {
        case "upcoming":
          result = "status-upcoming";
          break;
        case "in progress":
          result = "status-inprogress";
          break;
        case "cancelled":
          result = "status-cancelled";
          break;
        case "completed":
          result = "status-completed";
          break;
      }
    return result;
  }

  /**
   * This method gets called when filter icon is clicked
   */
  async onMenuFilterClick() {
    // let filter = await this.modal.create(CompetitionFilterPage);
    const filter = await this.modal.create({
      component: CompetitionFilterPage,
      cssClass: 'self-adjustable-modal',
      mode:'ios',
    });
    filter.onDidDismiss().then((applyFilter: any) => {
      console.debug("on menu filter dismiss ", applyFilter)
      if (applyFilter?.data) {
        this._clearAndRefresh(null, null);

      let _param = this.mg2uUtil.getClubParam();
      if (_param) {
        this.competitionService.setClubId(this.mg2uUtil.getClubId())
      }
      else if (!_param && appType === 'club' && clubId) {
        let _clubId = clubId;
        this.competitionService.setClubId(_clubId)
      }
      this.searchCriteria = this.competitionService.getSearch();
      this.tabs = this.searchCriteria.searchType;
      this.competitionService.setSearch(this.searchCriteria);

      this.mg2uUtil.setSearchPref('comp.countryId', this.searchCriteria?.countryId );
      if(!!this.searchCriteria?.searchType) this.filterStatus = this.searchCriteria?.searchType

      this.viewMode = this.searchCriteria?.viewMode;
    }

      if (
        this.searchCriteria.countryId === null ||
        this.searchCriteria.countryId === ''
      ) {
        this.selectedCountry = null;
        this.filterCountry = null;
      }
      if(this.searchCriteria.countryId) {
        this.filterCountry = this.countryList?.find((c)=>{
          return c.id === this.searchCriteria.countryId
        })
      }
    });
    if (this.platform.is('ios') && this.platform.is('capacitor'))
      this.keyboard.hide();
    filter.present();
    // this.router.navigate(['tabs/player-home']);
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick() {
    console.debug("do on refresh click")
    this.doRefresh(null);
    // this._clearAndRefresh(null, null);
  }

  onCompetitionClick(item: CompetitionDataLite) {
    let navigationExtras: NavigationExtras = {
      // queryParams: {
      state: {
        competition: item,
        compId: item?.id,
        // competition: item,
        animate: false,
      },
    };
    this.router.navigate(['competition-details'], navigationExtras);
  }

  onHomeClick() {
    // this.nav.popToRoot();//this.nav.setRoot(PlayerHomePage);
    // this.nav.popToRoot();
    this.router.navigate(['tabs/player-home'], { replaceUrl: true });
  }

  onSearchInput(searchbar) {
    console.debug("do search", this.searchQuery)
    // if(this.searchQuery?.length < 3) return;
    if(this.initPage) return;
    this._clearAndRefresh(null, null);
    this.mg2uUtil.setSearchPref('comp.list', this.searchQuery);
    this.searchCriteria.searchQuery = this.searchQuery;
    this.competitionService.setSearch(this.searchCriteria);
  }

  /**
   * When loadMore button is clicked
   */
  onLoadMoreClick() {
    this._refresh(null, null);
  }

  doRefresh(refresher) {
    console.debug("do refresh")
    this.clearAllSubs();
    this._clearAndRefresh(null, refresher);
  }

  doInfinite(infinite) {
    console.debug("do infinite", this.compDataPage, )
    // this.infinite = infinite;
    if (this.isMore()) {
      this._refresh(infinite, null);
    } else {
      infinite.target.complete();
    }
  }

  public isMore() {
    return (
      this.compDataPage.totalPages > 0 &&
      this.compDataPage.currentPage < this.compDataPage.totalPages
    );
  }

  /**
   * This will clear the current competition list and
   * reloads from the server
   * @private
   */
  private _clearAndRefresh(infinite, refresher) {
    this.getCountry();
    this._initItems();
    this._getCountryList();
    this._refresh(infinite, refresher);
  }

  subCompList: Subscription;
  subCountryList: Subscription;
  clearAllSubs() {
    if(this.subCompList) {
      this.subCompList.unsubscribe();
      this.subCompList = null;
    }
    if(this.subCountryList) {
      this.subCountryList.unsubscribe();
      this.subCountryList = null;
    }
  }
  private async _refresh(infinite, refresher) {

    console.debug("on refresh comp list ", this.refreshAttempted, this.subCompList, infinite, refresher,
    this.compList.competitions, this.compDataPage.items);
    // if(this.subCompList) return;
    if(this.subCompList && (!infinite || !refresher)) return;
    let loader = await this.loading.create({
      spinner: null,
      message: `
                <b>Loading competitions...</b>
            `,
    });
    // if(!infinite && !this.refreshAttempted) return;
    this.refreshAttempted = false;
    if(!infinite) {
      this.compList.competitions = []
      this.compDataPage.items = [];
    }
    // await loader.present().then(() => {
      // if(0) //! disable
      // this.subCompList = this.competitionService
      //   .search(this.compList.currentPage + 1, this.searchQuery)
      //   .subscribe({
      //     next: (compList: CompetitionList) => {
      //       loader.dismiss().then(() => {
      //         this.refreshAttempted = true;
      //         if (compList.totalPages > 0) compList.currentPage++;
      //         this.compList.currentPage = compList.currentPage;
      //         this.compList.totalPages = compList.totalPages;
      //         this.compList.totalItems = compList.totalItems;
      //         this.compList.competitions.push(...compList.competitions);
      //         if (this.compList.totalPages > 0)
      //           this.statistics =
      //             'CompetitionListPage.displaying' +
      //             ' ' +
      //             this.compList.competitions.length +
      //             ' / ' +
      //             this.compList.totalItems +
      //             ' ' +
      //             'CompetitionListPage.competitions';
      //         else this.statistics = '';
      //         this.compList.competitions = this.compList.competitions.sort(
      //           (a, b) => {
      //             if (a.status === 'In Progress' && b.status === 'In Progress') {
      //               if (a.startDate < b.startDate) return 1
      //               else if (a.startDate > b.startDate) return -1
      //               else return 0
      //             } else if (a.status === 'Upcoming' && b.status === 'Upcoming') {
      //               if (a.startDate < b.startDate) return -1
      //               else if (a.startDate > b.startDate) return 1
      //               else return 0
      //             } else return 0
      //           }
      //         );
      //       });
      //     },
      //     error: (error) => {
      //       loader.dismiss();
      //       this.subCompList.unsubscribe();
      //     },
      //     complete: () => {
      //       if (refresher) {
      //         refresher.target.complete();
      //       }
      //       if (infinite) {
      //         infinite.target.complete();
      //       }
      //       this.subCompList.unsubscribe();
      //     }
      //   }
      //   );
    // });
    let params = {
      clubId: this.searchCriteria?.clubId,
      organizerId: this.searchCriteria?.organizerId,
      countryId: this.searchCriteria?.countryId,
      status: this.filterStatus || this.searchCriteria?.searchType,
      teamEvent: '',
      latestFirst: true, //default true
      privateCompetition: this.searchCriteria?.privateCompetition, //Yes | No | Both
      startDate: this.searchCriteria?.searchDateFrom,
      endDate: this.searchCriteria?.searchDateTo,
      search: this.searchCriteria?.searchQuery || this.searchQuery,
      partOfLeague: this.searchCriteria?.partOfLeague,
      seasonId: null,
      pageSize: this.pageSize, //60,
      playerParticipation: this.searchCriteria?.onlyParticipating?'P':'',
      excludeElapsed: this.searchCriteria?.excludeElapsed
      // pageNo: this.compDataPage.currentPage + 1 || 1
    }
    this.subCompList = this.flightService.getCompListLiteSecured(this.compDataPage.currentPage + 1, params)
    .subscribe((compDataPage: CompetitionDataLitePage) =>{
      console.debug("on refresh comp list ", this.subCompList)
        if(compDataPage) {
          // if (compDataPage.totalPages > 0) compDataPage.currentPage++;
          this.compDataPage.currentPage = compDataPage.currentPage;
          this.compDataPage.totalPages = compDataPage.totalPages;
          this.compDataPage.totalItems = compDataPage.totalItems;
          this.compDataPage.items.push(...compDataPage.items);
          if (this.compDataPage.totalPages > 0)
            this.statistics =
              'CompetitionListPage.displaying' +
              ' ' +
              this.compDataPage.items?.length +
              ' / ' +
              this.compDataPage.totalItems +
              ' ' +
              'CompetitionListPage.competitions';
          else this.statistics = '';
        }

        this.compDataPage.items = this.compDataPage.items.sort(
          (a, b) => {
            if (a.status === 'In Progress' && b.status === 'In Progress') {
              if (a.startDate < b.startDate) return 1
              else if (a.startDate > b.startDate) return -1
              else return 0
            } else if (a.status === 'Upcoming' && b.status === 'Upcoming') {
              if (a.startDate < b.startDate) return -1
              else if (a.startDate > b.startDate) return 1
              else return 0
            } else return 0
          }
        );
        this.compDataPage.items = this.compDataPage?.items?.filter((comp, idx)=>{
          console.debug("items : ", idx, comp?.publishDate);
          console.debug("items : ", moment().isSameOrAfter(moment(comp?.publishDate, 'YYYY-MM-DD'),'days'));
          let _publishDateTime = moment(comp?.publishDate + ' ' + comp?.publishTime, 'YYYY-MM-DD HH:mm:ss')
          let _isPublished = moment().isSameOrAfter(_publishDateTime,'second');
          return _isPublished;
        })
        if(this.searchCriteria?.privateCompetition === 'Both') {
          this.compDataPage.items = this.compDataPage?.items?.filter((comp, idx)=>{
            if(comp?.privateEvent === false) return true;
            else if(comp?.privateEvent === true && comp?.registered) return true;
            else return false;
        })
        }
        if (refresher) {
          refresher.target.complete();
        }
      },(error)=>{
        if(this.subCompList && !infinite) {
          this.subCompList.unsubscribe();
          this.subCompList = null;
        }
        if (infinite) {
          infinite.target.complete();
          if(this.subCompList) {
            this.subCompList.unsubscribe();
            this.subCompList = null;
          }
        }
        this.refreshAttempted = true;
        if (refresher) {
          refresher.target.complete();
        }
      },() =>{
        if(this.subCompList && !infinite) {
          this.subCompList.unsubscribe();
          this.subCompList = null;
        }
        if (infinite) {
          infinite.target.complete();
          if(this.subCompList) {
            this.subCompList.unsubscribe();
            this.subCompList = null;
          }
        }
        this.refreshAttempted = true;
        if (refresher) {
          refresher.target.complete();
        }
      });
  }
  compDataPage: CompetitionDataLitePage;

  private _initItems() {
    this.compList = emptyCompetitionList();
    this.compDataPage = emptyCompetitionDataLitePage();
  }

  private _getCountryList() {
    if(this.subCountryList) return;
    this.subCountryList = this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {
        let countryList = data;
        if (this.searchCriteria.countryId) {
          this.selectedCountry = countryList.filter((c: Country, idx: number) => {
            return c.id == this.searchCriteria.countryId
          }).pop();
        }
      },(error)=>{
        if(this.subCountryList) {
          this.subCountryList.unsubscribe();
          this.subCountryList = null;
        }
      },()=>{
        if(this.subCountryList) {
          this.subCountryList.unsubscribe();
          this.subCountryList = null;
        }
      });

  }
  getImageError(event: Event, comp) {
    let _compImage = comp && comp.image ? comp.image : 'assets/image/default/default_competition.jpg';
    (event.target as HTMLImageElement).src = _compImage;
  }


  getImgSizeClass(comp: CompetitionDataLite, type?: string) {
    let _style = 'cover';


    const myImage = new Image();

    let  image = '';
    if(type === 'thumbnail' && comp?.image) {
      image = comp?.image;
    } else if(type === 'full' && comp?.image) {
      image = comp?.image;
    } else if(type === 'default') {
      image = 'assets/image/default/default_competition.jpg'; //'img/default_competition.png'
    } else {
      if(comp?.image) image = comp?.image;
      else image = 'assets/image/default/default_competition.jpg'; // 'img/default_competition.png'
    }
    // console.debug("get img size class ", image, type, comp)
    if(image?.toLowerCase().includes('default_competition')) return 'cover';

    if(image) {
      myImage.src = image;
      let _ratio = myImage.width / myImage.height;
      if(1) { // new
        if(_ratio === 1) {
          _style = 'contain';
        }
        // else if (_ratio >= 1.5 || _ratio <= 0.75) {
        else if (_ratio >= 1.3 || _ratio <= 0.75) {
          _style =  'cover';
        }
        else if ((_ratio >= 0.99 && _ratio <= 1) || (_ratio < 1 && _ratio >= 0.88)) {
          _style =  'cover';
        } else {
          _style = 'contain';
        }
      }
      // console.debug("get image size : ", _style, _ratio, myImage, myImage.width / myImage.height, image, type)

      return _style;
    }


    // if(image) {
    //   this.mg2uUtil.convertStringToImage(image).then((img)=>{
    //     let _ratio = img.width / img.height;
    //     // if(myImage.width > myImage.height) {
    //       // if(_ratio > 1.5 || _ratio < 0.67 ) {
    //       //   _style = 'cover';
    //       // } else _style = 'contain';
    //     // }  else if(myImage.width < myImage.height) {
    //     //   if(_ratio > 1.5 || _ratio < 0.67 ) {
    //     //     _style = 'contain';
    //     //   } else _style = 'cover';
    //     // } else _style = 'contain';

    //     if(1) { // new
    //       if(_ratio === 1) {
    //         _style = 'contain';
    //       }
    //       else if (_ratio >= 1.5 || _ratio <= 0.75) {
    //         _style =  'cover';
    //       }
    //       else if ((_ratio >= 0.99 && _ratio <= 1) || (_ratio < 1 && _ratio >= 0.88)) {
    //         _style =  'cover';
    //       } else {
    //         _style = 'contain';
    //       }
    //     }

    //     // console.debug("get image size : ", _style, _ratio, myImage, myImage.width / myImage.height, image, type)
    //     // console.log(myImage.width)
    //     // console.log(myImage.height)
    //     return _style;
    //   })
    //   .catch(()=>{
    //     return '';
    //   })
    // }
    else return '';
  }


  getTotalRegistered(comp: CompetitionDataLite, maxOnly: boolean = false) {
    if(!comp) return;
    let _totalRegistered = 0;
    if(maxOnly) {
      // if(comp.maxPlayers <= comp.totalRegistered)
      //   _totalRegistered = comp.maxPlayers
      // else _totalRegistered = comp.totalRegistered;
      _totalRegistered = comp.totalRegistered;
    } else {
      _totalRegistered = comp.totalRegistered | 0;
    }

    return _totalRegistered;
  }



  filterCountry: Country;
  countryList: Array<Country>;
  async onSelectCountry() {
    console.debug("country : ", this.filterCountry)
    let modal = await this.modalCtrl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: 'Select Country',
        excludeAll: false,
      },
    });
   modal.onDidDismiss().then((country?: any) => {
      let _country: Country = country.data;
      if (!country.data || country.data === -999) {
        this.filterCountry = null
        this.searchCriteria.countryId = '';
      }
      else {
        this.filterCountry = _country;
        this.searchCriteria.countryId = _country.id;
      }

      this.mg2uUtil.setSearchPref('comp.countryId', _country.id );
      this.competitionService.setSearch(this.searchCriteria);
      this._clearAndRefresh(null,null);
      setTimeout(()=>{
        this.getCountryInfo();
      },150)
      this.changeDetectorRef.detectChanges();
    });
    await modal.present();
  }


  getCountryInfo() {
    if (!this.filterCountry) {
      console.log("IFFFFF", this.filterCountry)
      // this.searchCriteria.countryId = ''
      // console.log(' this.searchCriteria.countryId: ',  this.searchCriteria.countryId);
      return 'All Countries'
    }
    else {
      console.log("ELSEEEEE", this.filterCountry, this.searchCriteria);
      // this.searchCriteria.countryId = this.filterCountry?.id
      return this.filterCountry && this.filterCountry?.name};
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '')
      return '../../../../assets/img/flag/default_worldwide.png';
    else {
      let flagIcon = flagUrl.split('/');
      return '../../../../assets/img/flag/' + flagIcon[2];
    }
  }

  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {
        this.countryList = data;
        if(data?.length > 0) {
          console.debug("init country ", this.countryList, this.searchCriteria, this.filterCountry);
          console.debug("init country [1]", this.countryList.find(country => country.id === this.searchCriteria.countryId));
          if(this.searchCriteria?.countryId) {
            this.filterCountry = this.countryList.find(country => country.id === this.searchCriteria.countryId);
            console.debug("init country [2]", this.filterCountry);
          }
        }
      });
  }


  parseFilterStartDate(type: string) {
    if(!this.searchCriteria?.searchDateFrom) return;
    if(this.searchCriteria?.searchDateFrom) {
      if(type === 'month')
        return moment(this.searchCriteria.searchDateFrom).format("MMM 'YY")
      else if(type === 'full') {
        // return moment(this.searchCriteria.searchDateFrom).format("DD MMMM YYYY")
        return moment(this.searchCriteria.searchDateFrom).format("DD MMM YYYY")
      }
    }
  }

  filterStatus: string = 'all';
  async onChangeFilterStatus() {

    let _dataList = [{
      id: 'Upcoming',
      name: 'Upcoming',
      iconUrl: 'assets/icons/golf-website.png'
    },{
      id: 'In Progress',
      name: 'In Progress',
      iconUrl: 'assets/icons/golf-website.png'
    },{
      id: 'Completed',
      name: 'Completed',
      iconUrl: 'assets/icons/golf-website.png'
    },{
      id: 'Cancelled',
      name: 'Cancelled',
      iconUrl: 'assets/icons/golf-website.png'
    },{
      id: 'all',
      name: 'Any Status',
      iconUrl: 'assets/icons/golf-website.png'
    }
    ]
      const modal = await this.modalCtrl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            headerTitle: 'Filter by status',
            selectedValue: this.filterStatus,
        }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data)
      if(data?.data) {
        if(data?.data?.id !== 'all') {
          this.searchCriteria.status = data?.data?.id;
          this.filterStatus = data?.data?.id;
        } else if(data?.data?.id === 'all') {
          this.searchCriteria.status = 'all';
          this.filterStatus = 'all';
        }
        this.competitionService.setSearch(this.searchCriteria);
        this.onRefreshClick();
      }
      // if(data)

    })
  }

  confirmDate() {
    if(this.initPage) return;
    this.searchCriteria.searchDateFrom = moment(this.startDate,'YYYY-MM-DD').toDate();
    this.competitionService.setSearch(this.searchCriteria);
    this.onRefreshClick();
  }


  isClosedForRegistration(compData: CompetitionDataLite) {
    let _currDate = moment();
    let _closeDate = moment(compData?.closeDate);
    return _currDate.isAfter(_closeDate, 'day');
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  onToggleViewMode() {
    if(this.searchCriteria?.viewMode === 'compact') {
      this.searchCriteria.viewMode = 'classic';
    } else if(this.searchCriteria?.viewMode === 'classic') {
      this.searchCriteria.viewMode = 'compact';
    } else this.searchCriteria.viewMode = 'classic';
    this.competitionService.setSearch(this.searchCriteria);
  }

  isSmallerDevice() {
    return this.platform?.width() <= 320
  }
}

// interface Extracted {
//   searchQuery: string;
//   statistics: string;
//   refreshAttempted: boolean;
//   compList: CompetitionList;
//   competition: CompetitionDataLite;
//   selectedItem: NavParams;
//   tabs: string;
//   isAndroid: boolean;
//   countDays: number;
//   countDaysText: string;
//   countDaysRound: number;
//   searchCriteria: SearchCriteria;
//   needsRefresh: boolean;
//   selectedCountry: Country;
//   startDate: string;
//   viewMode: string;
//   subCompList: Subscription;
//   subCountryList: Subscription;
//   compDataPage: CompetitionDataLitePage;
//   filterCountry: Country;
//   countryList: Array<Country>;
//   filterStatus: string;
//   /* TODO: add the missing return type */
//   ngOnInit(): any;
//   /* TODO: add the missing return type */
//   ionViewDidEnter(): Promise<any>;
//   /* TODO: add the missing return type */
//   ionViewWillLeave(): any;
//   /* TODO: add the missing return type */
//   startDaysText(competition): any;
//   /* TODO: add the missing return type */
//   setSearchType(searchType: string): any;
//   /* TODO: add the missing return type */
//   regDaysText(competition): any;
//   /* TODO: add the missing return type */
//   getStatusIcon(competition: CompetitionDataLite): any;
//   /* TODO: add the missing return type */
//   getStatusClass(competition: CompetitionDataLite): any;
//   /* TODO: add the missing return type */
//   onMenuFilterClick(): Promise<any>;
//   /* TODO: add the missing return type */
//   onRefreshClick(): any;
//   /* TODO: add the missing return type */
//   onCompetitionClick(item: CompetitionDataLite): any;
//   /* TODO: add the missing return type */
//   onHomeClick(): any;
//   /* TODO: add the missing return type */
//   onSearchInput(searchbar): any;
//   /* TODO: add the missing return type */
//   onLoadMoreClick(): any;
//   /* TODO: add the missing return type */
//   doRefresh(refresher): any;
//   /* TODO: add the missing return type */
//   doInfinite(infinite): any;
//   /* TODO: add the missing return type */
//   isMore(): any;
//   /* TODO: add the missing return type */
//   clearAllSubs(): any;
//   /* TODO: add the missing return type */
//   getImageError(event: Event, comp): any;
//   /* TODO: add the missing return type */
//   getImgSizeClass(comp: CompetitionDataLite, type?: string): any;
//   /* TODO: add the missing return type */
//   getTotalRegistered(comp: CompetitionDataLite): any;
//   /* TODO: add the missing return type */
//   onSelectCountry(): Promise<any>;
//   /* TODO: add the missing return type */
//   getCountryInfo(): any;
//   /* TODO: add the missing return type */
//   getFlagUrl(flagUrl: string): any;
//   /* TODO: add the missing return type */
//   getCountry(): any;
//   /* TODO: add the missing return type */
//   parseFilterStartDate(type: string): any;
//   /* TODO: add the missing return type */
//   onChangeFilterStatus(): Promise<any>;
//   /* TODO: add the missing return type */
//   confirmDate(): any;
//   /* TODO: add the missing return type */
//   isClosedForRegistration(compData: CompetitionDataLite): any;
//   /* TODO: add the missing return type */
//   isMobileLayout(): any;
//   /* TODO: add the missing return type */
//   onToggleViewMode(): any;
//   /* TODO: add the missing return type */
//   isSmallerDevice(): any;
// }
